import { openFavoritesTracking, openRecentsTracking, openCollectionsTracking } from '@common/MyLists/tracking';
import { MY_LISTS_ACTIONS } from './ActionConstants';

export const openFavorites = () => (dispatch) => {
    dispatch({ type: MY_LISTS_ACTIONS.openFavorites });
    openFavoritesTracking();
};

export const openRecents = () => (dispatch) => {
    dispatch({ type: MY_LISTS_ACTIONS.openRecents });
    openRecentsTracking();
};

export const openCollections = () => (dispatch) => {
    dispatch({ type: MY_LISTS_ACTIONS.openCollections });
    openCollectionsTracking();
};

export const closePanel = () => (dispatch) => {
    dispatch({ type: MY_LISTS_ACTIONS.closePanel });
};
